import { useAudio } from '../../hooks/useAudio.js';

export function Button({ onClick, children, variant = 'primary', disabled = false, className = '' }) {
  const audio = useAudio();

  const variants = {
    primary: 'bg-amber-700 hover:bg-amber-800 text-amber-50 border-amber-900',
    secondary: 'bg-amber-200 hover:bg-amber-300 text-amber-900 border-amber-600',
    danger: 'bg-red-700 hover:bg-red-800 text-red-50 border-red-900'
  };

  const handleClick = () => {
    if (!disabled) {
      audio.playSound('ui_confirm');
      onClick?.();
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`px-6 py-3 rounded-xl font-bold border-2 shadow-lg transition-all transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
}
